<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .atta {
        flex-wrap: wrap;
        li {
            img {
                @include w_h(146px);
            }
        }
    }

    .detail_title {
        font-size: 15px;
        color: #333333;
        padding: 0 9px;
        border-left: 3px solid $mainColor;
        margin-bottom: 10px;
    }

    .detail_remark {
        padding: 10px;
        border: 1px solid #DCDFE6;
        line-height: 22px;
    }
</style>
<template>
    <div id="patientDetail" class="detail pt20 bg_fff">
        <div v-if="showTag" class="flex aic jcc pt100 pb100 column">
            <img src="../../assets/blank-default.png" alt="">
            <p class="pt15">暂无信息</p>
        </div>
        <div v-else class="pl15 pr15">
            <template v-if="Object.values(historyRecipeOrder).length>0">
                <p class="detail_title">患者信息：</p>
                <renewal-drug-info :info="historyRecipeOrder"
                                   :list="historyRecipeOrder.drugList"
                ></renewal-drug-info>
            </template>
            <!--网络诊间-->
            <template v-else-if="bizType === 'ONLINE_OUTPATIENT'">
                <online-pat-info :info="info" class="flex1" :inRecipe="true"></online-pat-info>
            </template>
            <template v-else>
                <div class="fs12 color_333">
                    <p class="detail_title">患者信息：</p>
                    <p class="bold">
                        【
                        {{info.commpatName||info.compatName||info.consulterName}}
                        {{info._sex}}
                        {{info._age||info.consulterAge||info.compatAge||info.commpatAge}}
                        】
                    </p>
                    <p class="pt10">
                        联系电话：{{info.commpatMobile||info.compatMobile||info.consulterMobile}}
                        <span class="pl20" v-if="info.commpatMedicalRecord||info.compatHosCardId">
                            就诊卡号：{{info.commpatMedicalRecord||info.compatHosCardId}}
                        </span>
                    </p>
                    <p class="pt10" v-if="info._replyTimeDetail||info.consultTime">
                        申请时间：{{info._replyTimeDetail||timeFormat(info.consultTime,'%Y年%m月%d日 %H:%M')}}</p>
                </div>
                <div class="pt20 fs12">
                    <p class="detail_title">备注信息：</p>
                    <p class="detail_remark">{{info.remark||info.consultContent||'无'}}</p>
                </div>
                <div class="pt20">
                    <p class="detail_title">申请图片：</p>
                    <ul class="flex atta">
                        <li v-for="(pic,index) in attaList" :key="pic.id"
                            class="flex0 mr10 pb10 pointer"
                            @click="scan(index,attaList)">
                            <img :src="pic.attaFileUrl" alt="">
                        </li>
                    </ul>
                </div>
            </template>
        </div>
        <pic-scan ref="scan"></pic-scan>
    </div>
</template>

<script>
  import {formatFloat, isEmpty} from "../../lib/utils";
  import {renewalService} from "../../lib/service/renewal";
  import {BOOKHOSID, RENEWAL_CHUFANG_TYPE} from "../../lib/config";
  import * as R from 'ramda';
  import VScroll from "../common/v-scroll";
  import PicScan from "../common/pic-scan";
  import {sexFilter} from "../../lib/filters";
  import {timeFormat} from "../../lib/utils";
  import RenewalDrugInfo from "../renewal/renewal-durg-info";
  import OnlinePatInfo from "../../components/online/pat-info";

  export default {
    name: "patient-detail",
    components: {RenewalDrugInfo, PicScan, VScroll, OnlinePatInfo},
    props: {
      info: {
        type: Object,
        default: () => {
          return {};
        }
      },
      recipe: Object
    },
    data() {
      return {
        height: 0,
        picWidth: 0,
        // xfxx: [],
        attaList: [],
        historyRecipeOrder: {},
        recipeInfo:{},
        bizType: '',
      }
    },
    computed: {
      showTag() {
        return isEmpty(this.info);
      }
    },
    filters: {
      sexFilter
    },
    created() {
      const H = document.body.clientHeight;
      this.height = H - 70 - 20 - 40 - 20 - 40 - 20;
    },
    watch: {
      info: {
        handler() {
            if (this.info){
                this.attaList = this.info.attaList ?  this.info.attaList: []
                this.historyRecipeOrder = this.info.historyRecipeOrder? this.info.historyRecipeOrder: {}
            }

        },
        deep: true,
        immediate: true
      },
      recipe: {
        handler(newV) {
          this.recipeInfo = newV
          this.bizType = newV.bizType
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      timeFormat,
      scan(index, list) {
        this.$refs.scan.show(index, list.map(r => r.attaFileUrl));
      },
    },
  }
</script>

